/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';

export function toggles() {
  $('.accordion__toggle').hide();
  $('.accordion__title').on('click tap', function () {
    $(this).toggleClass('active');
    $(this).parent().find('.accordion__toggle').slideToggle();
  });
}
